import { Row, RowProps } from 'antd';
import React, { memo } from 'react';

export const WidgetList = memo<RowProps>(props => {
	return <Row gutter={[20, 50]} {...props} />;
});
